var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotStartedStatusPin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9277 0.5C16.6864 0.500227 21.3545 5.16903 21.3545 10.9277C21.3543 16.6862 16.6862 21.3543 10.9277 21.3545C5.16903 21.3545 0.500231 16.6864 0.5 10.9277C0.5 5.16889 5.16889 0.5 10.9277 0.5Z",
    fill: "url(#paint0_linear_86_583)",
    stroke: "#C0C0C0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_86_583",
    x1: 10.9273,
    y1: 1,
    x2: 10.9273,
    y2: 20.8546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE0B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#820B0B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotStartedStatusPin);
export default __webpack_public_path__ + "static/media/NotStartedStatusPin.75ce4a793ad9473da4fa3b2c3e24282e.svg";
export { ForwardRef as ReactComponent };